import request from "root/js/request";

export const postSplitToSupplies = async ({
  cabinet_id,
  map,
  dates,
  alter_quantity,
  barcode_id__not_in,
  sales_share_history_period,
}) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/`,
    method: "post",
    params: {
      cabinet_id,
      sales_share_history_period,
      barcode_id__not_in,
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};

export const postSplitToSuppliesByDate = async ({
  cabinet_id,
  map,
  dates,
  alter_quantity,
  barcode_id__not_in,
  sales_share_history_period,
  exclude_region_clusters,
  query_date,
}) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/${query_date}/`,
    method: "post",
    params: {
      cabinet_id,
      sales_share_history_period,
      barcode_id__not_in,
      exclude_region_clusters
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};
